<template>
    <div class="winterGameDetail">
        <div class=" table">
            <dl :style="{ 'padding': !footer ? 0 : '' + 'px' }">
                <dt>
                    <ul class="">
                        <li v-for="(item, i) in headerList" :key="i"> {{ item }}</li>
                    </ul>
                </dt>
                <dd class="con-dd">
                    <template v-if="dataList && dataList.team_members.length > 0">
                        <ul class="con-ul-list" v-for="(item, index) in dataList && dataList.team_members" :key="index">
                            <li class="text-line2">{{ item.real_name || '-' }}</li>
                            <li>{{ item.subject || '-' }}</li>
                            <li>{{ item.score || 0 }}</li>
                            <li>{{ item.pk_count || 0 }}</li>
                            <li>{{ Math.round(Number(item.win_rate || 0) / 100)}}%</li>
                            <li class="detail" v-if="footer" @click="handleDetail(item)">详情</li>
                        </ul>
                    </template>
                    <div class="flex-vertically-center empty-data" v-else>暂无数据</div>
                </dd>
            </dl>
            <div class="total" v-if="footer">
                <ul class="">
                    <li>合计</li>
                    <li></li>
                    <li>{{ total.score || 0 }}</li>
                    <li>{{ total.pk_count || 0 }}</li>
                    <li>{{ Math.round(Number(total.win_rate || 0) / 100)}}%</li>
                    <li></li>
                </ul>
            </div>
        </div>
    </div>

</template>
<script>
export default {
    props: {
        dataList: {
            type: Object,
            default: () => { }
        },
        headerList: {
            type: Array,
            default: () => ['姓名', '学科', '奖杯数', '局数', '胜率', '操作']
        },
        total: {
            type: Object,
            default: () => { }
        },
        footer: {
            type: Boolean,
            default: () => true
        }
    },
    methods: {
        handleDetail(item) {
            let { account_id, subject } = item || {}
            this.$router.push({
                path: '/winterGame/memberDetail',
                query: {
                    account_id,
                    subject
                }
            })
        },
    },
}
</script>
<style lang="less" scoped>
@import "../../assets/style/global.less";

.empty-data {
    color: #c8c9cc;
    font-size: 20px;
    min-height: 400px;
}

.winterGameDetail {
    .table {
        width: 94%;
        margin: 0 auto;

        ul {
            display: flex;
            justify-content: space-between;
            padding: 0 20px 0;
            text-align: center;

            li {
                width: 19%;

                &:first-child {
                    width: 110px;
                }
                &:nth-child(3){
                    width: 24%;
                }

                // &:first-child{
                //     text-align: left;
                // }
                // &:last-child {
                //     text-align: right;
                // }
            }
        }

        dl {
            padding: 48px 0 96px;

            dt {
                width: 100%;
                height: 46px;
                line-height: 46px;
                background: linear-gradient(135deg, #1B94FF 0%, #23B0FF 100%) #CBE7FF;
                border-radius: 20px;

                ul {
                    li {
                        color: #fff;
                        font-size: 24px;
                    }
                }
            }

            dd {
                width: 100%;
                max-height: 640px;
                min-height: 500px;
                line-height: 46px;
                overflow-y: auto;
                margin: 0;
                padding-bottom: 30px;

                ul {
                    margin-top: 20px;

                    li {
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #333333;
                        line-height: 34px;

                        &.detail {
                            color: #1C96FF;
                        }
                    }
                }
            }
        }

        .total {
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 64px;
            line-height: 64px;
            background: linear-gradient(135deg, #1B94FF 0%, #23B0FF 100%);
            box-shadow: 0px -4px 12px 0px rgba(0, 0, 0, 0.4);
            border-radius: 0px 0px 8px 8px;
            color: #fff;

            ul {
                width: 94%;
                margin: 0 auto;

                li {
                    &.hide {
                        opacity: 0;
                    }
                }
            }
        }
    }
}
</style>